import React, { ReactNode } from 'react';

type TeaserListHeadlineProps = {
  invisible?: boolean;
  children: ReactNode;
};

export function TeaserListHeadline({ invisible = false, children }: TeaserListHeadlineProps) {
  return <h2 className={invisible ? 'invisible' : 'teaser-list__headline font-bold-24-28'}>{children}</h2>;
}
